import { gql } from '@apollo/client'

export const CREATE_CONTACT_INQUIRIES_MUTATION = gql`
	mutation createContactForm($contactType: ContactFormTypeEnum!, $content: String) {
		createContactForm(contactType: $contactType, content: $content) {
			id
			status
		}
	}
`
